import type { FaireProductEntity } from "../../entity_types/product";

export const p_g3t9xbnkuz: FaireProductEntity = {
  token: "p_g3t9xbnkuz",
  type: "product",
  name: "Shilajit Resin",
  brandToken: "b_a3tpqf5bwb",
  brandName: "Double Wood Supplements",
  imageUrl:
    "https://cdn.faire.com/fastly/9bd522eb4cc728d0bdead026524ea544df63f7e521b3cb917ee03b9ea7ef00bf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/376c728dd633c0aea9a65645ca14475d9dd21eb8ea4a73c969b6e718b08c945e.jpeg",
    "https://cdn.faire.com/fastly/be43a5828cf3f27aac10d4780786c27f9ea7adc7a0d83fe6db2a11f6997182cb.jpeg",
    "https://cdn.faire.com/fastly/732511e4d566165a7bc7d38c28ff26e706385a47c532d8e7cd3fc94a71a8f043.jpeg",
    "https://cdn.faire.com/fastly/3d9f43e0b84cb5d6f85c87c359fd14085323dc10c78a4d1181782afe0d709012.jpeg",
  ],
  priceDollars: 19.73,
  description:
    "Shilajit is a sticky substance found primarily in rocks of the Himalayas and is believed to have developed over hundreds of years from the slow decomposition of plants. While Shilajit has a long history of use in Ayurvedic medicine, it has only recently become popular in the West as a source of bioactive Fulvic Acid.\n\nDouble Wood’s Shilajit contains no fillers and is standardized to 20% bioactive Fulvic Acid, which is seen as the main active ingredient. In addition to this, it may contain up to 84 different minerals.",
  tags: [],
  msrpDollars: 27.64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:44.260Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
